import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react';
import { ModalStore } from './modal_store';
import baseStyles from './modal.module.css';
import { Theme, ThemedStyles, useStyles } from '../theme';

type ModalStyles = {
  modal: string;
  visible: string;
  backdrop: string;
};

const themedStyles: ThemedStyles<ModalStyles> = {
  [Theme.DAYLIGHT]: {
    modal: baseStyles.modal,
    visible: baseStyles.visible,
    backdrop: baseStyles.backdrop,
  },
  [Theme.MIDNIGHT]: {
    modal: baseStyles.modal,
    visible: baseStyles.visible,
    backdrop: baseStyles.backdrop,
  },
};

export type ModalProps = {
  store: ModalStore;
  showBackdrop?: boolean;
  onBackdropClick?: () => void;
  children: React.ReactNode;
};

// The children of our modal need to implement their own classes!
export const Modal = observer(({ store, showBackdrop = true, onBackdropClick = store.hideModal, children }: ModalProps) => {
  const styles = useStyles(themedStyles);
  return (
    <div className={classNames(styles.modal, { [styles.visible]: store.visible })}>
      {showBackdrop && <div className={styles.backdrop} onClick={onBackdropClick}/>}
      {children}
    </div>
  );
});
